import React from 'react';

import { AuctionTitleContainer } from '../AuctionTitleContainer';
import { BookedOfferLayoutsLinkContainer } from '../BookedOfferLayoutsLinkContainer';
import { GeoContainer } from '../GeoContainer';
import { IdenticalOffersLinkContainer } from '../IdenticalOffersLinkContainer';
import { LabelsListContainer } from '../LabelsListContainer';
import { PriceContainer } from '../PriceContainer';
import { RatingContainer } from '../RatingContainer';
import { ResizableContainer } from '../ResizableContainer';
import { SimilarLinkContainer } from '../SimilarLinkContainer';
import { TitleContainer } from '../TitleContainer';
import { CommercialAreaPartsContainer } from '../commercial/CommercialAreaPartsContainer';
import { CoworkingAmenitiesContainer } from '../commercial/CoworkingAmenitiesContainer';
import { CoworkingWorkplacesCountContainer } from '../commercial/CoworkingWorkplacesCountContainer';

interface IOfferGeneralInfoContainerProps {
  isNewHighlighting: boolean;
}

export function OfferGeneralInfoContainer({ isNewHighlighting }: IOfferGeneralInfoContainerProps) {
  return (
    <>
      <TitleContainer />
      <CoworkingWorkplacesCountContainer />
      <LabelsListContainer />
      <GeoContainer />
      <AuctionTitleContainer />
      <PriceContainer isNewHighlighting={isNewHighlighting} />
      <CommercialAreaPartsContainer />
      <RatingContainer />
      <ResizableContainer />
      <CoworkingAmenitiesContainer />
      <SimilarLinkContainer />
      <IdenticalOffersLinkContainer />
      <BookedOfferLayoutsLinkContainer />
    </>
  );
}
